import React from 'react';
import { StyledFileInfo, StyledText } from './styles';
import { FileUploadListItemFileInfoErrorMessage } from './FileUploadListItemFileInfoErrorMessage';
import { ViewportSize } from "../../common";
import { useViewportSize } from "../../hooks";
export const FileUploadListItemFileInfo = ({ file, translateFn }) => {
    const viewportSize = useViewportSize();
    const isLargeScreen = viewportSize.size !== ViewportSize.EXTRA_SMALL;
    return (React.createElement(StyledFileInfo, null,
        React.createElement(StyledText, null, file.fileName),
        isLargeScreen && (React.createElement(FileUploadListItemFileInfoErrorMessage, { file: file, translateFn: translateFn }))));
};
//# sourceMappingURL=FileUploadListItemFileInfo.js.map